/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Deal_CreatedInputs */

const cs_enum_deal_created = /** @type {(inputs: Enum_Deal_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod vytvořen`)
};

const en_enum_deal_created = /** @type {(inputs: Enum_Deal_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal created`)
};

/**
* | output |
* | --- |
* | "Deal created" |
*
* @param {Enum_Deal_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_deal_created = /** @type {((inputs?: Enum_Deal_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Deal_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_deal_created(inputs)
	return cs_enum_deal_created(inputs)
});